import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode"
import { EntityEnum } from "../../EntityEnum";
import { MFLEntityListView } from "../../../Data/MedicinalProductData/MFLEntityListView";
import { MFLAutoUploadEntity } from "../Entity/MFLAutoUploadEntity";
import { BaseNode } from "../../BaseNode";

export class TreeNodeMedicinalProductsMFL extends SimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new MFLEntityListView(items), 'Master File Locations', useHist ? EntityEnum.mflHist : EntityEnum.mfl);
        this.useHist = useHist;
    }

    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${model.ev_Code} - ${model.masterfiledesc}`;
        return this.addChildNode(MFLAutoUploadEntity,labelTemplate, this,model,this.useHist, false, false);
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code', 'mflcountryname', 'mflcountrycode', 'mflpostcode', 'mflstate', 'mflcity', 'mflstreet', 'mflbuilding', 'mfldepartment', 'mflcompany' ];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for master file locations available in the XEVMPD [visibility restrictions may apply] including those owned by your HQ";
    }
}